// Язык интерфейса как значение, без побочных эффектов.
//
// Модуль намеренно отделён от config.ts: тот при импорте инициализирует
// i18next, и компоненты, которые мокают react-i18next в тестах, ломались бы
// только оттого, что спросили название языка.

export const SUPPORTED_LANGS = ['en', 'ru'] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];
export const DEFAULT_LANG: Lang = 'en';

/**
 * Код языка без региона.
 *
 * `i18n.language` хранит то, что вернул детектор: у посетителя с системной
 * локалью это 'ru-RU'. Переводы через t() при этом работают —
 * `nonExplicitSupportedLngs` резолвит их в 'ru', — а код, который смотрит на
 * язык сам, сравнивал с 'ru' и уходил в английскую ветку. Половина продукта
 * сравнивала строго, половина по префиксу, поэтому карта выдавала смесь:
 * «Сельскохозяйственная комарка · 24 municipalities», «Высота: 606 m».
 *
 * Единственный правильный способ спросить язык в коде — эта функция.
 */
export function uiLang(code?: string | null): Lang {
  return code?.toLowerCase().startsWith('ru') ? 'ru' : 'en';
}
